import { useSearchParams } from 'react-router';
import {
  ApiError,
  BadRequestError,
  NotFoundError,
  useApiWithErrors,
} from '@axiom/ui';

import { UserSearchesApi } from '../api/user-searches-api';

export const useSavedSearchFilters = () => {
  const [searchParams] = useSearchParams();
  const savedSearchId = searchParams.get('savedSearchId');

  const [savedSearch] = useApiWithErrors(
    savedSearchId ? UserSearchesApi.readUserSearch(savedSearchId) : undefined
  );

  if (!savedSearch) {
    return {};
  }

  if (savedSearch instanceof ApiError) {
    if (
      !(savedSearch instanceof NotFoundError) &&
      !(savedSearch instanceof BadRequestError)
    ) {
      throw savedSearch;
    }
    return {};
  }
  return savedSearch.data.search;
};
